import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryPeriodModel } from 'src/app/models/inventory/inventory-period.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryPeriodService {

  constructor(private _httpClient: HttpClient) { }

  createInventoryPeriod(inventoryPeriodModel: InventoryPeriodModel): Observable<InventoryPeriodModel> {
    return this._httpClient.post<InventoryPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.CreateInventoryPeriod}`,
      inventoryPeriodModel);
  }

  deleteInventoryPeriod(inventoryPeriodId: number): Observable<InventoryPeriodModel> {
    return this._httpClient.delete<InventoryPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.DeleteInventoryPeriod}/${inventoryPeriodId}`);
  }

  exportDocumentsForDelete(columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.ExportDocumentsForDelete}`, null,
      {
        params,
        responseType: 'blob',
      }
    );
  }

  exportDocumentsOpenedConsultation(columnSort: string | null, ascendant: boolean, rentalPeriodId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('rentalPeriodId', rentalPeriodId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.ExportDocumentsOpenedConsultation}`, null,
      {
        params,
        responseType: 'blob',
      }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllDocumentsForDeleteWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryPeriodId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('inventoryPeriodId', inventoryPeriodId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetAllDocumentsForDeleteWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllDocumentsOpenedWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryPeriodId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('inventoryPeriodId', inventoryPeriodId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetAllDocumentsOpenedWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllInventoryPeriodsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetAllInventoryPeriodsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetColumnsForGeneralConsultationAsync}`);
  }

  getLastInventoryPeriod(): Observable<InventoryPeriodModel> {
    return this._httpClient.get<InventoryPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetLastInventoryPeriod}`);
  }

  setActiveInventoryPeriod(inventoryPeriodId: number): Observable<InventoryPeriodModel> {
    return this._httpClient.put<InventoryPeriodModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.SetActiveInventoryPeriod}/${inventoryPeriodId}`,
      null);
  }

  getColumnsForDocumentsOpened(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryPeriod.GetColumnsForDocumentsOpenedAsync}`);
  }
}
